import { type SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import type { SuretyBondPreview } from "../../bond/agent/types";
import { bondPreviewsQueryKey } from "../bond.keys";

export const useAdminFetchAccountBondPreviews = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: bondPreviewsQueryKey(accountId),
		queryFn: async () =>
			await get<SuretyBondPreview[]>(`/v2/admin/surety/bonds/previews?accountId=${accountId}`),
		staleTime: 1000 * 60 * 5,
	});

	return {
		adminAccountBondPreviews: data,
		adminAccountBondPreviewsError: error,
		adminAccountBondPreviewsIsLoading: isLoading,
	};
};
